import React, { useEffect, Suspense } from 'react';
import { Loader } from 'smart-react';
import AffectedFilesData from '../Charts/AffectedFilesData';
import { useAffectedFilesByRepos } from '../../Services/DashboardQueries';
/**
 * Total Executions Card
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The AffectedFilesByRepos component.
 */
const AffectedFilesByRepos = ({ dates }) => {
  const { data, isLoading, isError } = useAffectedFilesByRepos(dates);
  return (
    <div>
      <Suspense fallback={<Loader />}>
        {isLoading && <Loader />}
        <AffectedFilesData reportData={data ?? []} />
      </Suspense>
    </div>
  );
};

export default AffectedFilesByRepos;
